import { setSelectedSource, setTypeGrouping } from "@/features/dataTableSlice";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
export function TypeSelection(props) {
  const typeGrouping = useSelector((state) => state.dataTable.typeGrouping);
  const dispatch = useDispatch();

  const handleTypeGroupChange = (e) => {
    dispatch(setTypeGrouping({ value: e.target.value }));
    switch (e.target.value) {
      case "shop":
        dispatch(setSelectedSource({ index: 0, value: "promoter_actual" }));
        dispatch(setSelectedSource({ index: 1, value: "promoter_actual" }));
        break;
      default:
        dispatch(setSelectedSource({ index: 0, value: "all_actual" }));
        dispatch(setSelectedSource({ index: 1, value: "all_actual" }));
        break;
    }
  };
  return (
    <FormControl sx={{ m: 1, width: 100 }}>
      <InputLabel id="typeGrouping-select-label">分類</InputLabel>
      <Select
        labelId="typeGrouping-select-label"
        id="typeGrouping-select"
        value={typeGrouping}
        label="date"
        onChange={handleTypeGroupChange}
      >
        <MenuItem value={"product"}>產品</MenuItem>
        <MenuItem value={"brand"}>品牌</MenuItem>
        <MenuItem value={"date"}>日期</MenuItem>
        <MenuItem value={"shop"}>店鋪</MenuItem>
      </Select>
    </FormControl>
  );
}
